var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"read-detail"},[_c('div',{staticClass:"big-title"},[_vm._v("评估结果")]),_c('div',{staticClass:"sub-title"},[_vm._v("评估得分")]),_c('div',{staticClass:"big-title"},[_vm._v("问卷详情")])])
}]

export { render, staticRenderFns }